module.exports = __webpack_public_path__ + "static/media/20210403_202832_462_IMG_0004.293c0508.jpg";